<template>
  <div class="conditionsReglement card-content">
    <div v-if="devisCommande" class="columns is-marginless">
      <div class="column is-4">
        <p class="label">
          {{$t(racineTraduction  + '.informations.penaltyLabel')}}
        </p>
        <div class="control has-icons-right">
          <input-currency v-model="devisCommande.tauxPenalite"
          :disabled="devisCommande.penalite">
          </input-currency>
            <span class="icon  is-right">
              <i>%</i>
            </span>
        </div>
        <div class="columns">
          <qd-checkbox class="column is-narrow pdr-0" size="is-medium"
            v-model="devisCommande.penalite"
            @input="videPenalite">
          </qd-checkbox>
          <div v-if="devisCommande.textPenalite
            && devisCommande.textPenalite.length > 0"
            v-html="devisCommande.textPenalite" class="column is-10 pdl-0" />
          <span v-else class="column is-10 pdl-0">
            {{$t(racineTraduction  + '.informations.penalty')}}
          </span>
        </div>
      </div>
      <div class="column is-3">
        <p class="label">
          {{$t(racineTraduction  + '.informations.discountRateLabel')}}
        </p>
        <div class="control  has-icons-right">
          <input-currency v-model="devisCommande.tauxEscompte"
            :disabled ="devisCommande.escompte">
          </input-currency>
          <span class="icon  is-right">
            <i>%</i>
          </span>
        </div>
        <div class="columns">
          <qd-checkbox class="column is-narrow pdr-0" size="is-medium"
            v-model="devisCommande.escompte" @input="videEscompte">
          </qd-checkbox>
          <span class="column is-10 pdl-0">
            {{$t(racineTraduction  + '.informations.discountRate')}}
          </span>
        </div>
      </div>
      <div class="column is-4">
        <p class="label">
          {{$t(racineTraduction  + '.informations.recoveryLabel')}}
        </p>
        <div class="columns">
          <qd-checkbox class="column is-narrow pdr-0" size="is-medium"
            v-model="devisCommande.recouvrement">
          </qd-checkbox>
          <span class="column is-10 pdl-0">
            {{$t(racineTraduction  + '.informations.recovery')}}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import inputCurrency from '@/components/general/inputCurrency';

export default {
  name: 'conditionsReglement',
  props: ['devisCommande', 'racineTraduction'],
  components: {
    inputCurrency,
  },
  data() {
    return {
    };
  },
  methods: {
    videEscompte() {
      if (this.devisCommande.escompte) {
        this.devisCommande.tauxEscompte = null;
      }
    },
    videPenalite() {
      if (this.devisCommande.penalite) {
        this.devisCommande.tauxPenalite = null;
      }
    },
  },
};
</script>

<style lang="scss">
  .conditionsReglement {
    .label {
      height: 15px!important;
      margin-bottom:15px;
  }
  .control {
    width: 150px;
    margin-bottom:15px;
  }
  .qd-checkbox {
    display: flex;
    align-items: flex-start;
  }
  .text {
    font-size: 0.80rem;
    font-family: 'Open Sans', sans-serif;
  }
}
</style>
